module.exports = __webpack_public_path__ + "static/media/bayerHeart.9117c686.jpg";